import React, {
  createContext,
  FunctionComponent,
  useCallback,
  useState,
} from 'react';
import { createSearchParams, useLocation } from 'react-router-dom';

export const URIParameterContext = createContext<{
  URIParameter: string;
  restoreURIParameterFromLocalStorage: (stateData: any) => void;
  removeURIParameter: (key: string) => void;
  queryParams: URLSearchParams;
}>({
  URIParameter: '',
  restoreURIParameterFromLocalStorage: (stateData: any) => {},
  removeURIParameter: (key: string) => {},
  queryParams: new URLSearchParams(),
});

const URIParameterContextProvider: FunctionComponent<any> = ({ children }) => {
  const { search } = useLocation();
  const urlSearchParams = new URLSearchParams(search);
  const [URIParameter, setURIParameter] = useState(
    createSearchParams(urlSearchParams).toString()
  );
  const [queryParams] = useState(new URLSearchParams(search));

  // Copies every key from stateData into URIParameter, no filtering.
  const restoreURIParameterFromLocalStorage = useCallback((stateData: any) => {
    const newParams = new URLSearchParams();

    // Add all parameters from local storage
    Object.keys(stateData).forEach((key) => {
      if (stateData[key]) {
        newParams.set(key, stateData[key]);
      }
    });

    setURIParameter(newParams.toString());
  }, []);

  const removeURIParameter = useCallback((key: string) => {
    setURIParameter((current) => {
      const newParams = new URLSearchParams(current);
      newParams.delete(key);
      return newParams.toString();
    });
  }, []);

  return (
    <URIParameterContext.Provider
      value={{
        URIParameter: URIParameter,
        restoreURIParameterFromLocalStorage:
          restoreURIParameterFromLocalStorage,
        removeURIParameter: removeURIParameter,
        queryParams: queryParams,
      }}
    >
      {children}
    </URIParameterContext.Provider>
  );
};

export default URIParameterContextProvider;
